import {
  aboutUs,
  accessibility,
  backmarketWarranty,
  boMerchant,
  buyingGuides,
  cookiePolicy,
  dataProtection,
  help,
  hireExternal,
  infosConsumer,
  insurances,
  legal,
  medium,
  modelsComparison,
  referFriend,
  studentGoodDeals,
  termsSale,
  termsUse,
} from './shared-links'
import type { FooterConfig } from './types'

export const nlConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [aboutUs, studentGoodDeals, accessibility, hireExternal],
      socials: [
        {
          name: 'instagram',
          href: 'https://www.instagram.com/backmarket_nl',
        },
        {
          name: 'linkedin',
          href: 'https://www.linkedin.com/company/back-market',
        },
        { name: 'facebook', href: 'https://www.facebook.com/backmarket' },
        { name: 'x', href: 'https://x.com/backmarket' },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.nl/nl-nl/seller/home',
        },
        boMerchant,
        {
          translationKey: 'payment',
          href: 'https://help.backmarket.com/hc/nl/articles/360026643854-Hoe-kan-ik-op-Back-Market-betalen-',
        },
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/nl/articles/360033250174-Wanneer-wordt-mijn-bestelling-bezorgd-',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/nl/categories/360002106194-Retouren-en-terugbetalingen-Returns-refunds-',
        },
        insurances,
        help,
        buyingGuides,
        modelsComparison,
      ],
    },
    {
      titleKey: 'categoryServices',
      links: [referFriend],
    },
    {
      titleKey: 'categoryLaw',
      links: [
        termsUse,
        termsSale,
        backmarketWarranty,
        dataProtection,
        cookiePolicy,
        infosConsumer,
        legal,
        {
          translationKey: 'illegalContent',
          href: 'https://help.backmarket.com/hc/nl/requests/new?ticket_form_id=12226993197084',
        },
        { translationKey: 'paymentMethods', href: '' },
      ],
    },
    {
      titleKey: 'categoryHello',
      links: [
        {
          translationKey: 'trustpilot',
          href: 'https://www.trustpilot.com/review/www.backmarket.nl',
        },
        {
          translationKey: 'glassdoor',
          href: 'https://www.glassdoor.nl/Overzicht/Werken-bij-Back-Market-EI_IE1780208.11,22.htm',
        },
        medium,
      ],
    },
    {
      logos: ['bcorp'],
    },
  ],
}
